import { render, staticRenderFns } from "./HeaderMenuForeign.vue?vue&type=template&id=1ebc5614&scoped=true"
import script from "./HeaderMenuForeign.vue?vue&type=script&lang=js"
export * from "./HeaderMenuForeign.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenuForeign.vue?vue&type=style&index=0&id=1ebc5614&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebc5614",
  null
  
)

export default component.exports